import _ from "lodash";
import moment from "moment";

const handleDateFormatField = (dimensions) => {
  let dateFormat = {};
  dimensions?.map((dim) => {
    if (dim?.dateFormat) {
      dateFormat[dim?.fieldName + "_date"] = dim?.dateFormat;
    } else if (dim?.timeFormat) {
      dateFormat[dim?.fieldName + `_${dim?.timeFormatType}`] = dim?.timeFormat;
    }
  });
  return dateFormat;
};
export const handleColumnDisplayName = (report) => {
  const measures = report?.measures;
  const dimensions = report?.dimensions;
  const timeDimensions = report?.timeDimensions;
  const displayObj = {};

  if (measures && measures.length) {
    measures.forEach((ele) => {
      const { fieldName, displayName } = ele;
      if (displayName) {
        displayObj[fieldName] = displayName;
      }
    });
  }
  if (dimensions && dimensions.length) {
    dimensions.forEach((ele) => {
      const { fieldName, displayName } = ele;
      if (displayName) {
        displayObj[fieldName] = displayName;
      }
    });
  }

  if (timeDimensions && timeDimensions.length) {
    timeDimensions.forEach((ele) => {
      const { dimension, displayTitle, displayName } = ele;
      if (displayName) {
        displayObj[dimension] = displayTitle
          ? displayTitle
          : displayName
          ? displayName
          : dimension;
      }
    });
  }
  return displayObj;
};

const handleMeasureFieldFormat = (measures) => {
  const formatObj = {};
  if (measures && measures.length) {
    measures.forEach((ele) => {
      const { fieldName, fieldFormat } = ele;
      if (fieldFormat) {
        formatObj[fieldName] = fieldFormat;
      }
    });
  }
  return formatObj;
};

const handleReportFilters = (filters) => {
  if (filters.length) {
    return filters.map((f) => {
      if (f?.operator === "top" || f?.operator === "bottom") {
        f = { ...f, operator: "equals" };
      }
      return f;
    });
  } else {
    return filters;
  }
};

const handleReportFields = (reportFields) => {
  let fieldsArr = [];
  if (reportFields.length) {
    for (let fields of reportFields) {
      // if (!fields?.isHidden) {
      fieldsArr.push(fields?.fieldName);
      // }
    }
  }
  return fieldsArr;
};

const handleQueryOrderBy = (order) => {
  let orderBy = {};
  order?.forEach((ele) => {
    orderBy[ele?.content?.key] = ele?.content?.order;
  });
  return orderBy;
};
const handleFilterNullValues = (reportFilters) => {
  return reportFilters
    ?.filter((item) => {
      if (
        item.operator === "set" ||
        item.operator === "notSet" ||
        (item?.values?.length > 0 &&
          !item?.values.includes(null) &&
          !item?.values?.includes(""))
      ) {
        return item;
      }
    })
    ?.map((f) => {
      if (f.operator === "set" || f.operator === "notSet") {
        return {
          member: f?.member,
          operator: f?.operator,
        };
      } else {
        return {
          member: f?.member,
          operator: f?.operator,
          values: f?.values,
        };
      }
    });
};

const handlePivotConfigFormat = (pivot) => {
  let xArr = pivot?.xAxis?.list.map((ele) => ele.text);
  let yArr = [];

  if (pivot?.group?.list) {
    yArr = [
      ...pivot?.group?.list.map((ele) => ele?.text),
      ...pivot?.value?.list.map((ele) => ele?.text),
    ];
  } else {
    yArr = [...pivot?.value?.list.map((ele) => ele?.text)];
  }

  let lines = pivot?.lines?.list;
  let group = pivot?.group?.list;

  const config = {
    x: xArr,
    y: yArr,
    lines,
    group,
  };

  return config;
};

const handleRateChangeQuery = (reportDetailsQuery) => {
  if (
    (reportDetailsQuery?.settings?.rateChangeProps?.periodicity ||
      reportDetailsQuery?.settings?.rateChangeProps?.customVal) &&
    (reportDetailsQuery?.timeDimensions?.length ||
      reportDetailsQuery?.settings?.rateChangeProps?.dateField)
  ) {
    const reportFilters = handleReportFilters(
      reportDetailsQuery?.reportFilters
    );
    const { periodicity, customVal } =
      reportDetailsQuery?.settings?.rateChangeProps;
    let granularityDimension =
      reportDetailsQuery?.settings?.rateChangeProps?.dateField ||
      reportDetailsQuery?.timeDimensions[0]?.dimension;

    const queryProps = {
      chartType: reportDetailsQuery?.chartType,
      settings: reportDetailsQuery?.settings,
      query: [],
    };
    const showYearOnYearChange =
      reportDetailsQuery?.settings?.rateChangeProps?.showYearOnYearChange ||
      false;

    for (let i = 0; i < 2; i++) {
      let query = {
        measures: handleReportFields(reportDetailsQuery?.measures),
        order: handleQueryOrderBy(reportDetailsQuery?.orderBy),
        dimensions: handleReportFields(reportDetailsQuery?.dimensions),
        limit: reportDetailsQuery?.limit,
        timezone: "UTC",
        timeDimensions: reportDetailsQuery?.timeDimensions,
        filters: handleFilterNullValues(reportFilters),
        renewQuery: reportDetailsQuery?.renewQuery,
      };

      if (periodicity && !customVal) {
        switch (periodicity) {
          case "daily":
            if (i === 0) {
              query.timeDimensions = [
                {
                  dimension: granularityDimension,
                  dateRange: "Yesterday",
                  granularity: "day",
                },
              ];
            } else {
              query.timeDimensions = [
                {
                  dimension: granularityDimension,
                  dateRange: "Today",
                  granularity: "day",
                },
              ];
            }
            break;
          case "weekly":
            if (i === 0) {
              query.timeDimensions = [
                {
                  dimension: granularityDimension,
                  dateRange: "Last Week",
                  granularity: "week",
                },
              ];
            } else {
              query.timeDimensions = [
                {
                  dimension: granularityDimension,
                  dateRange: "This Week",
                  granularity: "week",
                },
              ];
            }
            break;
          case "monthly":
            if (i === 0) {
              query.timeDimensions = [
                {
                  dimension: granularityDimension,
                  dateRange: "Last Month",
                  granularity: "month",
                },
              ];
            } else {
              query.timeDimensions = [
                {
                  dimension: granularityDimension,
                  dateRange: "This Month",
                  granularity: "month",
                },
              ];
            }
            break;

          case "quarterly":
            if (i === 0) {
              query.timeDimensions = [
                {
                  dimension: granularityDimension,
                  dateRange: "Last Quarter",
                  granularity: "quarter",
                },
              ];
            } else {
              query.timeDimensions = [
                {
                  dimension: granularityDimension,
                  dateRange: "This Quarter",
                  granularity: "quarter",
                },
              ];
            }
            break;
          case "yearly":
            if (i === 0) {
              query.timeDimensions = [
                {
                  dimension: granularityDimension,
                  dateRange: "Last Year",
                  granularity: "year",
                },
              ];
            } else {
              query.timeDimensions = [
                {
                  dimension: granularityDimension,
                  dateRange: "This Year",
                  granularity: "year",
                },
              ];
            }
            break;
          default:
            return;
        }
      } else {
        let customVal =
          reportDetailsQuery?.settings?.rateChangeProps?.customVal;
        customVal = parseInt(customVal);
        let granularity;
        if (customVal === 1) {
          granularity = "day";
        } else if (customVal > 1 && customVal < 7) {
          granularity = "weeek";
        } else if (customVal >= 7 && customVal < 30) {
          granularity = "month";
        } else if (customVal >= 30 && customVal < 120) {
          granularity = "quarter";
        } else {
          granularity = "year";
        }

        let currEndDate = moment().format("YYYY/MM/DD");
        let currentStartDate = moment()
          .subtract(customVal - 1, "days")
          .format("YYYY/MM/DD");
        let prevEndDate = moment()
          .subtract(customVal, "days")
          .format("YYYY/MM/DD");
        let prevStartDate = moment()
          .subtract(customVal, "days")
          .subtract(customVal - 1, "days")
          .format("YYYY/MM/DD");

        const startDate = new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          1
        );

        if (new Date(prevStartDate) < startDate) {
          granularity = "year";
        } else {
          granularity = "month";
        }

        if (i === 0) {
          query.timeDimensions = [
            {
              dimension: granularityDimension,
              dateRange: [prevStartDate, prevEndDate],
              granularity: granularity,
            },
          ];
        } else {
          query.timeDimensions = [
            {
              dimension: granularityDimension,
              dateRange: [currentStartDate, currEndDate],
              granularity: granularity,
            },
          ];
        }
      }
      queryProps.query.push(query);
    }

    if (showYearOnYearChange) {
      const yoyQuery = {
        measures: handleReportFields(reportDetailsQuery?.measures),
        order: handleQueryOrderBy(reportDetailsQuery?.orderBy),
        dimensions: handleReportFields(reportDetailsQuery?.dimensions),
        limit: reportDetailsQuery?.limit,
        timezone: "UTC",
        timeDimensions: reportDetailsQuery?.timeDimensions,
        filters: handleFilterNullValues(reportFilters),
        renewQuery: reportDetailsQuery?.renewQuery,
      };
      if (periodicity && !customVal) {
        let start, end, granularity;

        switch (periodicity) {
          case "daily": {
            start = moment()
              .startOf("day")
              .subtract(1, "year")
              .format("YYYY-MM-DD");
            end = moment()
              .endOf("day")
              .subtract(1, "year")
              .format("YYYY-MM-DD");
            granularity = "day";
            break;
          }

          case "weekly": {
            start = moment()
              .startOf("week")
              .subtract(1, "year")
              .format("YYYY-MM-DD");
            end = moment()
              .endOf("week")
              .subtract(1, "year")
              .format("YYYY-MM-DD");
            granularity = "week";
            break;
          }

          case "monthly": {
            start = moment()
              .startOf("month")
              .subtract(1, "year")
              .format("YYYY-MM-DD");
            end = moment()
              .endOf("month")
              .subtract(1, "year")
              .format("YYYY-MM-DD");
            granularity = "month";
            break;
          }

          case "quarterly": {
            start = moment()
              .startOf("quarter")
              .subtract(1, "year")
              .format("YYYY-MM-DD");
            end = moment()
              .endOf("quarter")
              .subtract(1, "year")
              .format("YYYY-MM-DD");
            granularity = "quarter";
            break;
          }

          case "yearly": {
            start = moment()
              .startOf("year")
              .subtract(1, "year")
              .format("YYYY-MM-DD");
            end = moment()
              .endOf("year")
              .subtract(1, "year")
              .format("YYYY-MM-DD");
            granularity = "year";
            break;
          }

          default:
            return;
        }

        yoyQuery.timeDimensions = [
          {
            dimension: granularityDimension,
            dateRange: [start, end],
            granularity: granularity,
          },
        ];
      } else {
        let customVal =
          reportDetailsQuery?.settings?.rateChangeProps?.customVal;
        customVal = parseInt(customVal);
        let granularity;
        if (customVal === 1) {
          granularity = "day";
        } else if (customVal > 1 && customVal < 7) {
          granularity = "weeek";
        } else if (customVal >= 7 && customVal < 30) {
          granularity = "month";
        } else if (customVal >= 30 && customVal < 120) {
          granularity = "quarter";
        } else {
          granularity = "year";
        }

        let prevEndDate = moment()
          .subtract(customVal, "days")
          .subtract(1, "years")
          .format("YYYY/MM/DD");
        let prevStartDate = moment()
          .subtract(customVal, "days")
          .subtract(customVal - 1, "days")
          .subtract(1, "years")
          .format("YYYY/MM/DD");

        const startDate = new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          1
        );

        if (new Date(prevStartDate) < startDate) {
          granularity = "year";
        } else {
          granularity = "month";
        }
        yoyQuery.timeDimensions = [
          {
            dimension: granularityDimension,
            dateRange: [prevStartDate, prevEndDate],
            granularity: granularity,
          },
        ];
      }
      queryProps.query.push(yoyQuery);
    }

    return queryProps;
  }
  return null;
};
const getReportFieldsKey = (reportDetails) => {
  let info = { measureKey: [], dimensionKey: [] };
  if (reportDetails?.reportDetails?.measures.length) {
    info.measureKey = reportDetails?.reportDetails?.measures.map(
      (meas) => meas?.fieldName
    );
  }
  if (reportDetails?.reportDetails?.dimensions.length) {
    info.dimensionKey = reportDetails?.reportDetails?.dimensions.map(
      (dim) => dim?.fieldName
    );
  }
  return info;
};
const getHiddenFields = (fields) => {
  let fieldsArr = [];
  if (fields.length) {
    for (let field of fields) {
      if (field?.isHidden) {
        fieldsArr.push(field?.fieldName);
      }
    }
  }
  return fieldsArr;
};

const convertPivotConfig = (pivot, result) => {
  let config = {
    xAxis: {
      id: "xAxis",
      list: [],
      label: "X Axis",
    },
    value: {
      id: "value",
      list: [],
      label: "Value",
    },
    lines: {
      id: "Lines",
      list: [],
      label: "Lines",
    },
    group: {
      id: "group",
      list: [],
      label: "Group",
    },
  };

  config.lines.list = pivot?.lines || [];
  config.group.list = pivot?.group || [];

  if (
    !pivot?.x?.length &&
    !pivot?.y?.length &&
    result &&
    result?.dimensions?.length
  ) {
    let dimensions = result?.dimensions.map((dim) => {
      return { text: dim?.fieldName, type: "dimensions", id: dim?.fieldId };
    });

    config.xAxis.list = dimensions;
    config.value.list = [{ id: "1", text: "measures", type: "measures" }];

    return config;
  } else {
    const xArr = pivot?.x;
    const yArr = pivot?.y;
    let measures = xArr?.map((meas) => {
      return {
        text: meas,
        type: "measures",
        id: Math.floor(Math.random() * 1000).toString(),
      };
    });

    let dimensions = yArr?.map((dim) => {
      if (result?.dimensions?.find((dimObj) => dimObj?.fieldName === dim)) {
        return {
          text: dim,
          type: "measures",
          id: Math.floor(Math.random() * 1000).toString(),
        };
      }
      return {
        text: dim,
        type: "dimensions",
        id: Math.floor(Math.random() * 1000).toString(),
      };
    });

    config.xAxis.list = measures;
    config.value.list = dimensions;

    return config;
  }
};

const formatOrderBy = (order, result) => {
  if (order && result) {
    const orderBy = Object.entries(order).map(([key, val]) => {
      return {
        id: Math.floor(Math.random() * 1000).toString(),
        content: {
          key: result?.dataSetId?.dataSetName + "." + key,
          order: val,
        },
      };
    });
    return orderBy;
  } else if (!order?.length && result) {
    let order = [];
    if (result?.dimensions?.length) {
      for (let dim of result?.dimensions) {
        let obj = {
          id: dim?.fieldId,
          content: {
            key: dim?.fieldName,
            order: "asc",
          },
        };
        order.push(obj);
      }
    }
    if (result?.measures?.length) {
      for (let meas of result?.measures) {
        let obj = {
          id: meas?.fieldId,
          content: {
            key: meas?.fieldName,
            order: "desc",
          },
        };
        order.push(obj);
      }
    }
    return order;
  }
};

const handleReportHyperLink = (result) => {
  let dataSetName = null;
  if (result.dimensions?.length > 0) {
    dataSetName = result.dimensions[0]?.fieldName?.split(".")[0];
  } else if (result.measures?.length > 0) {
    dataSetName = result.measures[0]?.fieldName?.split(".")[0];
  } else if (
    result.timeDimensions?.length > 0 &&
    result.timeDimensions[0].dimension
  ) {
    dataSetName = result.timeDimensions[0].dimension?.split(".")[0];
  }
  let { reportHyperlink } = result;
  return reportHyperlink;
};

const mapLinkedResponseData = (reportData) => {
  let clonedReportData = _.cloneDeep(reportData);
  return clonedReportData?.linkedReports?.map((reportObj) => {
    if (reportObj) {
      const pivotConfig = convertPivotConfig(
        reportObj?.reportId?.pivotConfig,
        reportObj?.reportId
      );
      const orderBy = formatOrderBy(
        reportObj?.reportId?.orderBy,
        reportObj?.reportId
      );

      reportObj.reportName = reportObj?.reportId?.reportName;
      if (reportObj.reportId) {
        reportObj.reportId.pivotConfig = pivotConfig;
        reportObj.reportId.orderBy = orderBy;
      }
    }
    return reportObj;
  });
};


export const reportFormatter = (reportArray) => {
  return reportArray.map((report) => {
    const pivotConfig = convertPivotConfig(report.pivotConfig, report);
    const orderBy = formatOrderBy(report.orderBy, report);
    report.pivotConfig = pivotConfig;
    report.orderBy = orderBy;
    report.noDataText = report.noDataText || "No Data";
    report.reportHyperlink =
      report.reportHyperlink && report.reportHyperlink.length
        ? handleReportHyperLink(report)
        : [
            {
              hyperlinkColumn: "",
              hyperlinkReportId: {},
              hyperlinkFilters: [],
              hyperlinkType: "",
              hyperlinkExtType: "",
              hyperlinkExtParams: [],
              hyperlinkExtQryParams: [{ name: "", field: "" }],
            },
          ];
    report.renewQuery = false;
    report.linkedReports = mapLinkedResponseData(report);
    report.mergeReport = report.mergeReport || {};
    report.settings.conditionalFormat = report.settings.conditionalFormat || [
      {},
    ];
    report.settings.pageSize = report.settings.pageSize || 10;
    report.settings.xAxisLabelDegree =
      report.settings.xAxisLabelDegree !== null &&
      report.settings.xAxisLabelDegree !== undefined
        ? report.settings.xAxisLabelDegree
        : 65;
    report.settings.alignment = report.settings.alignment || {
      header: "left",
      dimensions: "left",
    };
    report.settings.rateChangeProps = report.settings.rateChangeProps || {};
    report.settings.dataFormat = report.settings.dataFormat || {};
    report.settings.axisTitle = report.settings.axisTitle || {
      x: {},
      y: {},
      z: {},
    };
    report.settings.axisSettings = report.settings.axisSettings || { y: {} };
    report.settings.groupBySettings = report.settings.groupBySettings;
    report.settings.truncateSettings = report.settings.truncateSettings;
    report.settings.fillMissingDates =
      report.settings.fillMissingDates || false;
    return {
      ...report,
      updatedAt: new Date(report.updatedAt).toLocaleDateString(),
      createdBy: report.createdBy || "Unknown",
    };
  });
};

export const mapResponseForQuery = (reportDetailsQuery) => {
  let tempQuery = { vizState: {} };
  tempQuery.name = reportDetailsQuery?.reportName;
  const dateFormat = handleDateFormatField(reportDetailsQuery?.dimensions);
  const colDisplayName = handleColumnDisplayName(reportDetailsQuery);
  const fieldFormat = handleMeasureFieldFormat(reportDetailsQuery?.measures);
  const reportFilters = handleReportFilters(reportDetailsQuery?.reportFilters);
  let dimensionTitle = {};
  let measureTitle = {};

  reportDetailsQuery?.dimensions?.map((dim) => {
    let key = dim?.fieldName;
    dimensionTitle[key] = dim?.title;
  });
  reportDetailsQuery?.measures?.map((meas) => {
    let key = meas?.fieldName;
    measureTitle[key] = meas?.title;
  });
  tempQuery.report = reportDetailsQuery;

  tempQuery.vizState = {
    chartType: reportDetailsQuery?.chartType,
    query: {
      measures: handleReportFields(reportDetailsQuery?.measures),
      order: handleQueryOrderBy(reportDetailsQuery?.orderBy),
      dimensions: handleReportFields(reportDetailsQuery?.dimensions),
      timezone: "UTC",
      filters: handleFilterNullValues(reportFilters),
      renewQuery: reportDetailsQuery?.renewQuery,
      timeDimensions: reportDetailsQuery?.timeDimensions,
    },
    pivotConfig: handlePivotConfigFormat(reportDetailsQuery?.pivotConfig),
    columnState: reportDetailsQuery?.columnState,
    orderBy: reportDetailsQuery?.orderBy,
    isPivotEnabled: reportDetailsQuery?.isPivotEnabled,
    isLegendVisible: reportDetailsQuery?.isLegendVisible,
    legendPosition: reportDetailsQuery?.legendPosition,
    columnTitle: [{ ...dimensionTitle, ...measureTitle }],
    dateFieldFormat: dateFormat,
    columnDisplayName: colDisplayName,
    fieldFormat: fieldFormat,
    noDataText: reportDetailsQuery?.noDataText,
    reportHyperlink: reportDetailsQuery?.reportHyperlink || [],
    settings: reportDetailsQuery?.settings,
    rateChangeQuery: handleRateChangeQuery(reportDetailsQuery),
    toggleToTable: reportDetailsQuery?.toggleToTable,
    viewMode: "report",
    reportName: reportDetailsQuery?.reportName,
    description: reportDetailsQuery?.description,
    fieldsKeyInfo: getReportFieldsKey(reportDetailsQuery),
    hiddenFields: getHiddenFields([
      ...reportDetailsQuery?.measures,
      ...reportDetailsQuery?.dimensions,
    ]),
    comparisonChartType: reportDetailsQuery?.comparisonChartType,
  };
  tempQuery.vizState.query.filters = tempQuery.vizState.query.filters?.map(
    (item) => {
      if (item.operator === "set" || item.operator === "notSet") {
        return { member: item.member, operator: item.operator };
      }
      if (item?.member && item?.operator && item?.values?.length > 0)
        return {
          member: item.member,
          operator: item.operator,
          values: item.values,
        };
    }
  );
  return tempQuery;
};
